import { http, HttpResponse, bypass, passthrough } from 'msw';

import { NOT_ALLOWED_IN_DEMO } from 'utils/http';
import * as authHandlers from './auth';
import * as billingHandlers from './billing';
import * as salesHandlers from './sales';
import * as oracleHandlers from './oracle';
import * as devicesHandlers from './devices';
import * as auditHandlers from './auditLogs';
import * as encashHandlers from './encash';
import * as servicesHandler from './services';
import * as articlesHandlers from './articles';
import * as usersHandlers from './users';

const mocks = [
  authHandlers,
  billingHandlers,
  salesHandlers,
  oracleHandlers,
  devicesHandlers,
  auditHandlers,
  encashHandlers,
  servicesHandler,
  articlesHandlers,
  usersHandlers
];

export const handlers = [
  http.get(
    ({ request }) =>
      !request.headers.get('Accept')?.includes('application/json'),
    passthrough
  ),
  ...mocks.flatMap((mock) => Object.values(mock)),

  http.all('*/catalog/*', () => passthrough()),

  http.all('*', async ({ request }) => {
    if (request.url.includes('alivewater.online')) {
      await fetch(bypass(request));
      return HttpResponse.json(
        {
          DISABLED_IN_DEMO: true
        },
        { status: NOT_ALLOWED_IN_DEMO.code }
      );
    }
    return passthrough();
  })
];
